import axios from 'axios'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'
import { AuthService } from './auth'

function buildQrCodeUrl(params = {}) {
    const qs = CommonUtility.objectToParams(params)
    return qs ? `${APIPath.mobileQrCode}?${qs}` : APIPath.mobileQrCode
}

class MobileQrServiceClass {
    getQrCodeUrl(params = {}) {
        return buildQrCodeUrl(params)
    }

    async fetchQrCodeBlob(params = {}) {
        const token = AuthService.getToken()
        const response = await axios.get(buildQrCodeUrl(params), {
            baseURL: APIPath.server,
            headers: {
                'X-TOKEN': `${token}`,
                app: 'EAuditor',
                'Access-Control-Allow-Origin': '*',
                'X-LoginSource': '1',
            },
            responseType: 'blob',
        })
        const { data } = response
        return data
    }

    async downloadQrCode(params = {}, filename = 'qr-sticker.png') {
        const blob = await this.fetchQrCodeBlob(params)
        const url = URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = filename
        anchor.click()
        URL.revokeObjectURL(url)
    }
}

export const MobileQrService = new MobileQrServiceClass()
